import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class CustomUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    // const [path, queryString] = url.split('?');

    // const lowerCasePath = path.toLowerCase();

    // const lowerCaseUrl = queryString ? `${lowerCasePath}?${queryString}` : lowerCasePath;

    // return super.parse(lowerCaseUrl);
    
    let pathWithQuery = url;
    let queryString = '';

    const queryIndex = url.indexOf('?');
    if (queryIndex !== -1) {
      pathWithQuery = url.substring(0, queryIndex);
      queryString = url.substring(queryIndex + 1);
    }

    const lowerCasePath = pathWithQuery.split('/').map(segment => {
      return segment.startsWith(':') ? segment : segment.toLowerCase();
    }).join('/');

    let lowerCaseUrl = lowerCasePath;
    if (queryString) {
      lowerCaseUrl += `?${queryString}`;
    }

    return super.parse(lowerCaseUrl);
  }
}
